import axios from '../axios';
import { ON_LOAD_REG_BRANCH_INFORMATION } from '../ApiUrl';

/**
 * POST /OnLoadRegBranchInformation — uses Bearer from axios defaults (set at login).
 * @param {{ branchName: string, team_user_id: string }} payload
 */
export const onLoadRegBranchInformationAPI = async (payload) => {
  try {
    const response = await axios.post(ON_LOAD_REG_BRANCH_INFORMATION, payload);
    return response;
  } catch (error) {
    console.log('onLoadRegBranchInformationAPI catch block', error);
    return { hasError: true, error };
  }
};
